export const domainToProfileIdOptionsMap = {
    'c9a8aa49-9c91-4b84-5a06-b1772025a942': ['massachusetts', 'rhode-island', 'connecticut'],
}